import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import moment from "moment";
import "./returnsTable.style.scss";
import "react-datepicker/dist/react-datepicker.css";

class ReturnsTable extends Component {
  state = {
    selectTypeData: [],
    modifiedData: [],
    thOne: "date",
    thTwo: "returns",
    reset: false,
  };

  componentDidMount() {
    let data = this.props.historical_returns;
    console.log("-------------component did mount -----------", this.props);
    this.setData(data);
    if (data.length > 0) {
      this.uniqueDatesValidation(data);
    }
  }
  componentWillReceiveProps(nextProps) {
    let data = nextProps.historical_returns;
    this.setData(data);
    if (data.length > 0) {
      this.uniqueDatesValidation(data);
    }
  }

  uniqueDatesValidation = (data) => {
    // checking if dates are unique
    let all_dates = data.map((e) => e.date);
    let date_validation = all_dates.some(function (item, idx) {
      return all_dates.indexOf(item) != idx;
    });
    console.log(date_validation, "is_duplicate");

    //false - good to go there is no repeated dates
    // true - repeated dates are present
    this.props.historicReturnsValidation(date_validation);
  };
  setData = (data) => {
    let Data = data;
    let x = [...Data];
    let modifiedData = this.makeData(x);

    this.setState({
      modifiedData,
    });
  };
  makeData = (data) => {
    //  modifing data into array of arrays
    // number of objects inside of it depends on data length
    var n; //tweak this to add more items per line

    if (data.length <= 4) {
      n = 1;
    } else if (data.length > 4) {
      n = 4;
    }
    var result = new Array(Math.ceil(data.length / n))
      .fill()
      .map((_) => data.splice(0, n));

    return result;
  };
  tableHeading = (data) => {
    const { thOne, thTwo } = this.state;

    if (data && data.length > 0) {
      if (data.length <= 4) {
        return (
          <tr>
            <th>{thOne}</th>
            <th className="returnsColum">{thTwo}</th>
          </tr>
        );
      } else if (data.length > 4) {
        return (
          <tr>
            <th>{thOne}</th>
            <th className="returnsColum">{thTwo}</th>
            <th></th>
            <th>{thOne}</th>
            <th className="returnsColum">{thTwo}</th>
            <th></th>
            <th>{thOne}</th>
            <th className="returnsColum">{thTwo}</th>
            <th></th>
            <th>{thOne}</th>
            <th className="returnsColum">{thTwo}</th>
            <th></th>
          </tr>
        );
      }
    }
  };

  inputFieldHandler = (e) => {
    let { value } = e.target;
    let index = e.target.getAttribute("index");

    console.log(value, index);
    this.props.historicReturnsHandler({ index, key: "returns", value });

    setTimeout(() => this.setData(this.props.historical_returns), 100);
    setTimeout(
      () => this.uniqueDatesValidation(this.props.historical_returns),
      100
    );
  };

  dateFieldHandler = (date, index) => {
    console.log(date, index);
    let modifiedDate = moment(date).format("MM/DD/YYYY");

    console.log(modifiedDate, "modfied date");
    this.props.historicReturnsHandler({
      index,
      key: "date",
      value: modifiedDate,
    });

    setTimeout(() => this.setData(this.props.historical_returns), 100);
    setTimeout(
      () => this.uniqueDatesValidation(this.props.historical_returns),
      100
    );
  };
  tableBody = (modifiedData) => {
    let nodeList = [];
    for (let i = 0; i < modifiedData.length; i++) {
      nodeList.push(
        <tr key={`node_${i}`}>
          <td>
            <DatePicker
              closeOnScroll={true}
              selected={
                modifiedData[i][0] ? new Date(modifiedData[i][0]["date"]) : null
              }
              placeholderText="mm-dd-yyyy"
              onChange={(date) =>
                this.dateFieldHandler(date, modifiedData[i][0]["id"])
              }
            />
          </td>
          <td className="returnsColum">
            {modifiedData[i][0] ? (
              <input
                type="number"
                index={modifiedData[i][0]["id"]}
                defaultValue={modifiedData[i][0]["returns"]}
                onChange={(e) => this.inputFieldHandler(e)}
              />
            ) : null}
          </td>
          {modifiedData[i][1] ? <td></td> : null}
          {modifiedData[i][1] ? (
            <td>
              <DatePicker
                closeOnScroll={true}
                selected={
                  modifiedData[i][1] ? new Date(modifiedData[i][1]["date"]) : ""
                }
                placeholderText="mm-dd-yyyy"
                onChange={(date) =>
                  this.dateFieldHandler(date, modifiedData[i][1]["id"])
                }
              />
            </td>
          ) : null}
          {modifiedData[i][1] ? (
            <td className="returnsColum">
              <input
                type="number"
                index={modifiedData[i][1]["id"]}
                defaultValue={modifiedData[i][1]["returns"]}
                onChange={(e) => this.inputFieldHandler(e)}
              />
            </td>
          ) : null}
          {modifiedData[i][1] ? <td></td> : null}
          {modifiedData[i][2] ? (
            <td>
              <DatePicker
                closeOnScroll={true}
                selected={
                  modifiedData[i][2] ? new Date(modifiedData[i][2]["date"]) : ""
                }
                placeholderText="mm-dd-yyyy"
                onChange={(date) =>
                  this.dateFieldHandler(date, modifiedData[i][2]["id"])
                }
              />
            </td>
          ) : null}
          {modifiedData[i][2] ? (
            <td className="returnsColum">
              <input
                type="number"
                index={modifiedData[i][2]["id"]}
                defaultValue={modifiedData[i][2]["returns"]}
                onChange={(e) => this.inputFieldHandler(e)}
              />
            </td>
          ) : null}
          {modifiedData[i][2] ? <td></td> : null}
          {modifiedData[i][3] ? (
            <td>
              <DatePicker
                closeOnScroll={true}
                selected={
                  modifiedData[i][3] ? new Date(modifiedData[i][3]["date"]) : ""
                }
                placeholderText="mm-dd-yyyy"
                onChange={(date) =>
                  this.dateFieldHandler(date, modifiedData[i][3]["id"])
                }
              />
            </td>
          ) : null}
          {modifiedData[i][3] ? (
            <td className="returnsColum">
              <input
                type="number"
                index={modifiedData[i][3]["id"]}
                defaultValue={modifiedData[i][3]["returns"]}
                onChange={(e) => this.inputFieldHandler(e)}
              />
            </td>
          ) : null}
          {modifiedData[i][3] ? <td></td> : null}
        </tr>
      );
    }
    return nodeList;
  };

  render() {
    const { modifiedData } = this.state;
    const {
      historical_returns,
      historical_returns_error,
      portfolioTableActive,
      toggleButtonHandler,
      historical_upload_error,
      historical_error_name,
      historical_data_empty,
      historical_few_empty_columns,
    } = this.props;
    return (
      <Fragment>
        {historical_returns_error ||
        historical_upload_error ||
        historical_data_empty ||
        historical_few_empty_columns ? (
          <div className="analyze_table_warning">
            {historical_few_empty_columns ? (
              <span
                className="dataWarning"
                style={{
                  marginLeft: "auto",
                  marginBottom: "5px",
                }}
              >
                Some of the rows do not have valid data. They have been ignored.
              </span>
            ) : null}
            {historical_data_empty ? (
              <span
                className="dataWarning"
                style={{
                  marginLeft: "auto",
                  marginBottom: "5px",
                }}
              >
                Returns table uploaded is empty. Please populate historical
                returns by date and re-upload.
              </span>
            ) : null}
            <Fragment>
              {historical_upload_error ? (
                <span
                  className="dataWarning"
                  style={{
                    marginLeft: "auto",
                    marginBottom: "5px",
                  }}
                >
                  {`${historical_error_name.toUpperCase()} column missing. Please make sure "${historical_error_name}" column exists in the uploaded historical returns
                excel.`}
                </span>
              ) : null}
            </Fragment>
            {historical_returns_error ? (
              <span className="dataWarning" style={{ marginLeft: "auto" }}>
                Dates are not unique, Please make sure you uploaded unique date
                or you can edit below.
              </span>
            ) : null}
          </div>
        ) : null}

        {historical_returns.length > 0 ? (
          <div className="analyze_returns_btn">
            <button
              className={
                portfolioTableActive ? "analyze_returns_btn_active" : null
              }
              onClick={() => toggleButtonHandler(true)}
            >
              Portfolio
            </button>
            <button
              className={
                !portfolioTableActive ? "analyze_returns_btn_active" : null
              }
              onClick={() => toggleButtonHandler(false)}
            >
              Returns
            </button>
          </div>
        ) : null}
        <div className="returns_table">
          <table>
            <thead>
              {historical_returns && historical_returns.length > 0
                ? this.tableHeading(historical_returns)
                : null}
            </thead>
            <tbody>
              {modifiedData.length > 0 ? this.tableBody(modifiedData) : null}
            </tbody>
          </table>
        </div>
      </Fragment>
    );
  }
}

const mapDispatchToProps = {
  historicReturnsHandler: (payload) => ({
    type: "SET_UNIVERSE_LITE_HISTORICAL_RETURNS_VALUE",
    payload,
  }),
  historicReturnsValidation: (payload) => ({
    type: "SET_UNIVERSE_LITE_HISTORICAL_RETURNS_ERROR",
    payload,
  }),
};
export default connect(
  ({
    create: {
      modelportfolios,
      steps: {
        universeLite: { historical_returns, historical_returns_error },
      },
    },
  }) => ({ modelportfolios, historical_returns, historical_returns_error }),
  mapDispatchToProps
)(ReturnsTable);



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/Analyze/returnsTable/returnsTable.jsx